import StatTile from "@components/scheduling/analytics/StatTile";
import { formatCount, formatPercent, formatRatio, successesOf } from "@components/scheduling/analytics/format";

/**
 * The four headline figures: Successes (booked or transferred), Conversion,
 * Answered and Voicemail share. A missing field reads as zero or a dash,
 * never as an error, so a clinic that has not called anyone yet still sees
 * the shape of the page.
 */
export default function StatTiles({ numbers, loading = false }) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {[0, 1, 2, 3].map((i) => <StatTile key={i} loading />)}
      </div>
    );
  }
  const totals = numbers?.totals || {};
  const rates = numbers?.rates || {};
  const today = numbers?.today || {};
  const incomplete = totals.incomplete || 0;

  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      <StatTile
        label="Successes"
        tone="booked"
        value={formatCount(successesOf(totals))}
        sub={`today: ${formatCount(successesOf(today))}`}
        caption={`${formatCount(totals.booked)} booked · ${formatCount(totals.transferred)} transferred`}
      />
      <StatTile
        label="Conversion"
        tone="booked"
        value={formatPercent(rates.conversion)}
        sub={`today: ${formatPercent(today.conversion)}`}
        caption={`${formatRatio(successesOf(today), today.answered)} answered today`}
      />
      <StatTile
        label="Answered"
        value={formatCount(totals.answered)}
        sub={`today: ${formatCount(today.answered)}`}
        caption={incomplete > 0 ? `${formatCount(incomplete)} cut off` : null}
      />
      <StatTile
        label="Voicemail"
        tone="voicemail"
        value={formatPercent(rates.voicemail_share)}
        caption={`${formatRatio(totals.voicemail, totals.calls)} calls`}
      />
    </div>
  );
}
